import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from '@components/layout/index.js'
import { HomePage } from '@pages/home/HomePage.js'
import { ObraCommandPage } from '@pages/obra/ObraCommandPage.js'
import { JornadaPage } from '@pages/guia/JornadaPage.js'
import { PassoAtualPage } from '@pages/guia/PassoAtualPage.js'
import { ModuloDetailPage } from '@pages/modulos/ModuloDetailPage.js'
import { TopicoPage } from '@pages/modulos/TopicoPage.js'
import { FinanceiroPage } from '@pages/financeiro/FinanceiroPage.js'
import { DocumentosPage } from '@pages/documentos/DocumentosPage.js'
import { ChecklistPage } from '@pages/checklist/ChecklistPage.js'
import { ChecklistPendentesPage } from '@pages/guia/ChecklistPendentesPage.js'
import { ConfigPage } from '@pages/config/ConfigPage.js'
import { OnboardingPage } from '@pages/onboarding/OnboardingPage.js'
import { AlertasPage } from '@pages/alertas/AlertasPage.js'
import { DiarioPage } from '@pages/diario/DiarioPage.js'
import { CalculadorasPage } from '@pages/calculadoras/CalculadorasPage.js'
import { CalculadoraDetailPage } from '@pages/calculadoras/CalculadoraDetailPage.js'
import { MateriaisPage } from '@pages/materiais/MateriaisPage.js'
import { PendenciasPage } from '@pages/pendencias/PendenciasPage.js'
import { WikiPage } from '@pages/wiki/WikiPage.js'
import { WikiArticlePage } from '@pages/wiki/WikiArticlePage.js'
import { ContratosPage } from '@pages/contratos/ContratosPage.js'
import { ContratoDetailPage } from '@pages/contratos/ContratoDetailPage.js'
import { ContatosPage } from '@pages/contatos/ContatosPage.js'
import { CronogramaPage } from '@pages/cronograma/CronogramaPage.js'
import { DecisoesPage } from '@pages/decisoes/DecisoesPage.js'
import { ROUTES } from '@utils/constants.js'

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.ONBOARDING} element={<OnboardingPage />} />

        <Route element={<AppShell />}>
          <Route path={ROUTES.HOME} element={<HomePage />} />
          <Route path={ROUTES.PAINEL} element={<ObraCommandPage />} />
          <Route path={ROUTES.MODULOS} element={<JornadaPage />} />
          <Route path={ROUTES.ETAPA} element={<PassoAtualPage />} />
          <Route path={ROUTES.PASSO} element={<Navigate to={ROUTES.ETAPA} replace />} />
          <Route path={ROUTES.MODULO_DETAIL} element={<ModuloDetailPage />} />
          <Route path={ROUTES.TOPICO_DETAIL} element={<TopicoPage />} />
          <Route path={ROUTES.FINANCEIRO} element={<FinanceiroPage />} />
          <Route path={ROUTES.DOCUMENTOS} element={<DocumentosPage />} />
          <Route path={ROUTES.CHECKLIST} element={<ChecklistPage />} />
          <Route path={ROUTES.CHECKLIST_PENDENTES} element={<ChecklistPendentesPage />} />
          <Route path={ROUTES.ALERTAS} element={<AlertasPage />} />
          <Route path={ROUTES.DIARIO} element={<DiarioPage />} />
          <Route path={ROUTES.PENDENCIAS} element={<PendenciasPage />} />
          <Route path={ROUTES.CALCULADORAS} element={<CalculadorasPage />} />
          <Route path={ROUTES.CALCULADORA_DETAIL} element={<CalculadoraDetailPage />} />
          <Route path={ROUTES.MATERIAIS} element={<MateriaisPage />} />
          <Route path={ROUTES.CONTRATOS} element={<ContratosPage />} />
          <Route path={ROUTES.CONTRATO_DETAIL} element={<ContratoDetailPage />} />
          <Route path={ROUTES.CONTATOS} element={<ContatosPage />} />
          <Route path={ROUTES.CRONOGRAMA} element={<CronogramaPage />} />
          <Route path={ROUTES.DECISOES} element={<DecisoesPage />} />
          <Route path={ROUTES.WIKI} element={<WikiPage />} />
          <Route path={ROUTES.WIKI_ARTICLE} element={<WikiArticlePage />} />
          <Route path={ROUTES.CONFIG} element={<ConfigPage />} />
          <Route path={ROUTES.MAIS} element={<Navigate to={ROUTES.CONFIG} replace />} />
          <Route path='*' element={<Navigate to={ROUTES.HOME} replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
